import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/pages/products/industries/a-brake.jpg")